"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getContentType_1 = require("../helpers/getContentType");
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
const updateSubmissionCountForAssignment_1 = require("./helpers/updateSubmissionCountForAssignment");
const updateSubmissionCountForCheckpoint_1 = require("./helpers/updateSubmissionCountForCheckpoint");
const updateSubmissionCountForNonLeafNode_1 = require("./helpers/updateSubmissionCountForNonLeafNode");
/**
 * submissionCount field determines number of assignment
 * cards completed under this node. For assignment card it's
 * 1 if it's completed and 0 otherwise. This function also
 * updates actualSubmit flag on assignment cards.
 * actualSubmit is true on assignment card if all questions
 * below it have actualSubmit as true and false otherwise.
 */
// @ts-ignore: maintain function signature
function updateSubmissionCount(command, user, content, states) {
    const state = getState_1.getStateByContentIdUserId(states, content._id, user.userId);
    const contentType = getContentType_1.getContentType(content);
    switch (contentType) {
        case entity_1.ContentType.ASSIGNMENT_CARD:
            updateSubmissionCountForAssignment_1.updateSubmissionCountForAssignment(state, user, content, states);
            break;
        case entity_1.ContentType.SECTION:
        case entity_1.ContentType.COURSE: {
            const childrenContentIds = content.children.map((c) => c._id);
            updateSubmissionCountForNonLeafNode_1.updateSubmissionCountForNonLeafNode(state, user, childrenContentIds, states);
            break;
        }
        case entity_1.ContentType.CURRICULUM: {
            const childrenContentIds = content.offers.map((c) => c.offerId);
            updateSubmissionCountForNonLeafNode_1.updateSubmissionCountForNonLeafNode(state, user, childrenContentIds, states);
            break;
        }
        case entity_1.ContentType.CHECKPOINT:
            updateSubmissionCountForCheckpoint_1.updateSubmissionCountForCheckpoint(state);
            break;
        default:
            break;
    }
    return [];
}
exports.updateSubmissionCount = updateSubmissionCount;
//# sourceMappingURL=updateSubmissionCount.js.map